import styled from 'styled-components';

const LinkButton = styled.a`
  display: inline-block;
  text-decoration: underline;
  font-weight: 700;
  cursor: pointer;
  color: ${props => props.theme.colors.weployBlue};
`;

export default LinkButton;
